import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/settings/outlet')({
  loader: () => {
    return {
      crumb: 'Outlet',
    }
  },
})
